import React from 'react';
import PropTypes from 'prop-types';

export default class FullTextContentComponent extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      templateType: !this.props.fullTextIconUrl ? 'text' : null,
    };
  }

  componentDidMount() {
    if (this.state.templateType) return;

    const img = new Image();
    img.onload = () => {
      this.setState({
        templateType: 'image',
      });
    };
    img.onerror = () => {
      this.setState({
        templateType: 'text',
      });
    };
    img.src = this.props.fullTextIconUrl;
  }

  render() {
    return (
      <>
        {this.state.templateType && this.state.templateType === 'image' ? (
          <img alt="full text" src={this.props.fullTextIconUrl} />
        ) : (
          [
            <span key='0'>Full Text</span>,
            <svg key='1' className='els-btn-icon'>
              <use xlinkHref='#icon-up-right' />
            </svg>,
          ]
        )}
      </>
    );
  }
}

FullTextContentComponent.propTypes = {
  fullTextIconUrl: PropTypes.string,
};
